import DashboardUtils from "./DashboardUtils";
import CookieUtils from "./CookieUtils";
import startTimer from "./startTimer";
import * as Constans from "./Constans";

const DashboardUtilsInstance = new DashboardUtils();
const CookieUtilsInstance = new CookieUtils();

export {
  DashboardUtils,
  CookieUtils,
  DashboardUtilsInstance,
  CookieUtilsInstance,
  startTimer,
  Constans,
};
